import moment from 'moment';

export class SupportTypeDto {
  public id: number;
  public label;

  public static fromJson(json: any): SupportTypeDto {
    if (json) {
      return {
        id: json.id,
        label: json.label,
      } as SupportTypeDto;
    }
  }
}
